export enum ScreenshotType {
  Preview = 'Preview',
  Enlarge = 'Enlarge'
}
